import { useFeatures } from "components/FeatureFlag";

/*
  Two types of variation are possible. One will render the private insight with a modal, 
  while the other will render the SSO insight in the Workspace.

  Example of a JSON value returned by the first LD variation:
  {
    "clientCardTabs": [],
    "workflowReportMenu": [],
    "reportButton": [
      {
        "embedUrl": "https://report.myhubly.com/report1",
        "name": "Active Client Workflows"
      }
    ],
  }

  Example of a JSON value returned by the second LD variation:
  {
    "clientCardTabs": [],
    "workflowReportMenu": [],
    "reportButton": [
      {
        "dashboard": "active_client_workflows",
        "name": "Active Client Workflows"
      }
    ],
  }

  See https://app.launchdarkly.com/default/develop/features/looker-embedded-reports/variations
*/

function useInsightInfos(type) {
  const insights = useFeatures("looker-embedded-reports", { [type]: [] });

  if (!Array.isArray(insights?.[type])) {
    return [];
  }

  return insights[type]?.filter((r) => {
    return r?.name && (r?.embedUrl || r?.dashboard);
  });
}

export default useInsightInfos;
